if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.scrollPosition = 0;
        this.currentVisibleMediaId = null;
      }

      hide() {
        // Get the currently visible media in the modal before closing
        const visibleMediaId = this.getCurrentVisibleMediaId();
        
        // Remove overflow hidden from body
        document.body.classList.remove('overflow-hidden');
        
        super.hide();
        
        // Scroll to the corresponding image in the gallery
        if (visibleMediaId) {
          const galleryMedia = document.querySelector(
            `.product__media-item [data-media-id="${visibleMediaId}"], .product__media-item[data-media-id="${visibleMediaId}"]`
          );
          if (galleryMedia) {
            const mediaItem = galleryMedia.closest('.product__media-item') || galleryMedia;
            mediaItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } else {
          window.scrollTo(0, this.scrollPosition);
        }
      }

      show(opener) {
        super.show(opener);
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Add overflow hidden to body to prevent background scroll
        document.body.classList.add('overflow-hidden');
        
        this.showActiveMedia();
      }

      getCurrentVisibleMediaId() {
        const container = this.querySelector('[role="document"]');
        if (!container) return null;
        
        const mediaElements = this.querySelectorAll('[data-media-id]');
        const containerRect = container.getBoundingClientRect();
        const containerCenter = containerRect.top + containerRect.height / 2;
        
        let closestMedia = null;
        let closestDistance = Infinity;
        
        mediaElements.forEach((media) => {
          const rect = media.getBoundingClientRect();
          const mediaCenter = rect.top + rect.height / 2;
          const distance = Math.abs(mediaCenter - containerCenter);
          
          if (distance < closestDistance) {
            closestDistance = distance;
            closestMedia = media;
          }
        });
        
        return closestMedia ? closestMedia.getAttribute('data-media-id') : null;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
